export default __webpack_public_path__ + "static/media/prevArrowMob.1a92a353.svg";